import React from 'react';
import Section from '../common/Section';
import { Col, Row } from 'react-bootstrap';

function ErrorNotFound() {
  return (
    <Section className="py-0">
      <Row className="flex-center min-vh-75 pt-0 pt-lg-7">
        <Col sm={11} md={9} lg={7} xl={6} className="col-xxl-5 p-0">
          <div className="text-center">
            <div className="display-1 text-400 fs-error">404</div>
            <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold">
              The page you're looking for is not found.
            </p>
          </div>
        </Col>
      </Row>
    </Section>
  );
}

export default ErrorNotFound;
